import React, { useRef, useEffect, useState } from 'react';

const WhoWeAre = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);


  return (
    <section id="about" className="who-we-are" ref={sectionRef}>
      <div className="container">
        <div className={`section-content ${isVisible ? 'section-content--visible' : ''}`}>
          <div className="about-main">
            <div className="section-header">
              <div className="section-badge">
                <svg className="badge-icon" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z"/>
                </svg>
                <span className="badge-text">About Us</span>
              </div>
              <h2 className="section-title">
                Where <span className="title-accent">Engineering Excellence</span> 
                <br />Meets Product Innovation
              </h2>
            </div>
            
            <div className="about-content">
              <div className="content-block">
                <h3 className="content-subtitle">Product-First Technology Company</h3>
                <p className="content-text">
                  We are dedicated to solving complex information and decision-making challenges 
                  using <strong>applied AI</strong>, modern software design, and secure infrastructure.
                </p>
              </div>
              
              <div className="content-block">
                <h3 className="content-subtitle">Clarity Through Intelligence</h3>
                <p className="content-text">
                  Founded with a deep belief in clarity through intelligence, Thought Paradigm 
                  represents the convergence of cutting-edge technology and human-centered design.
                </p>
              </div>
              
              <div className="philosophy-highlight">
                <div className="highlight-quote">
                  <svg className="quote-icon" viewBox="0 0 24 24">
                    <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609v2.441c-2.984.448-4.02 2.081-4.02 4.793v2.735h4.02v8.031h-8.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609v2.441c-3.001.448-4.037 2.081-4.037 4.793v2.735h4.037v8.031h-9z"/>
                  </svg>
                  <p>We don't just build software — we build <em>systems that think</em>.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;
